import React from "react";
import { Segment, Divider } from "semantic-ui-react";
import { SemanticContainer, SemanticSegment } from "./styled";

import Back from "../Back";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import EditVacancyForm from "../EditVacancyForm";

const EditVacancy = () => {
  return (
    <div
      style={{
        padding: "0 0 0px 250px",
      }}
    >
      <AdminMenu />
      <SemanticContainer>
        <Back actualPage={"Editar"} />
        <h2>Editar Vaga</h2>
        <Divider />
        <Segment>
          <EditVacancyForm />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment>
          Grupo Voitto <i class="copyright outline icon"></i>
          {new Date().getFullYear()}
        </SemanticSegment>
      </SemanticContainer>
    </div>
  );
};

export default EditVacancy;
